import { Component, OnInit, Input, ViewEncapsulation, ViewContainerRef, NgModule, Compiler, ViewChild } from '@angular/core';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../services/common.service';
import { IContent } from '../interfaces/content.interface';
import { StoreConfig } from '../interfaces/store-config.interface';
import { ConfigurationService } from '../services/configuration.service';
import { MemberType } from '../../shared/enums/member-type.enum';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { MenuPortal } from '../../shared/enums/menu-portal.enum';
import { MenuItem } from '../../shared/interfaces/menu-item.interface';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from '../../../environments/environment';
import { DynamicRoute } from 'src/app/common/interfaces';

@Component({
  selector: 'not-found',
  templateUrl: '../templates/template1/views/not-found.component.html',
  styleUrls:
    ['../templates/template1/themes/default/less/not-found.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PageNotFoundComponent implements OnInit {
  //  cms inputs
  @Input() placeHolderName: string;
  @Input() sitemapNodeName: string;
  @ViewChild('DynamicHtmlContent', { read: ViewContainerRef, static: false }) container: ViewContainerRef;
  private countryName: string;
  languageCode: string;
  errorMessage: any = [];
  contenthtml: string = '';
  store: StoreConfig;
  appSites: MenuItem[];
  portalID: number;


  constructor(private _commonService: CommonService,
    private _cacheService: CacheService,
    private compiler: Compiler,
    private _localStorageService: LocalStorageService,
    private _configurationService: ConfigurationService) { }

  ngOnInit() {
    this.getStoreData();
    this.countryName = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.subscribeMenu();
  }

  /**
 * get store data from localstorage
 */
  getStoreData(): void {
    const storeData: StoreConfig = this._configurationService.getStoreData();
    if (storeData) {
      this.store = storeData;
    }
  }

  /**
  * To get footer data from cms
  */
  subscribeMenu(): void {
    const store: StoreConfig = this._configurationService.getStoreData();
    const countryId: number = this._cacheService.getCookieValue(CacheKey.CountryId);
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    let memberTypeId;
    const userBasicInfo: any = this._localStorageService.get('userInfo');
    if (userBasicInfo) {
      memberTypeId = userBasicInfo.memberTypeId === MemberType.DISTRIBUTOR ? MemberLevel.PREFERREDCUSTOMER : MemberLevel.RETAIL;
    } else {
      memberTypeId = MemberLevel.RETAIL;
    }
    this.portalID = MenuPortal.Corporate;
    if (this.portalID && store && store.id && countryId) {
      this._commonService.getApplicationSites(this.portalID, store.id, countryId, languageCode, memberTypeId)
        .subscribe(sites => {
          if (sites && sites.length > 0) {
            this.appSites = sites;
            // sessionStorage.setItem("menus", JSON.stringify(this.appSites));
            this.getContent();
          }
        });
    }
  }

  loadCmsData(sitemapId: number): void {
    const store: StoreConfig = this._configurationService.getStoreData();
    if (store && store.id && sitemapId) {
      this._commonService
        .getCMSContentBySiteMapId(sitemapId, store.homeIsocodeThree, store.id, this.portalID)
        .subscribe((response: any) => {
          if (response.pageContent) {
            this.contenthtml = response.pageContent;
          }
        }, (error: any) => {
          // this.contentHtml = `<div class="text-center" ><h1 style='text-align: center; '> NO CONTENT AVAILABLE </h1></div>`;
          (this.errorMessage = error);
        });
    }
  }
  getContent() {
    let menus = this.appSites;
    let obj: any;
    let notFoundslug = 'not-found';
    const menu = menus.find((item: MenuItem) => item.slug === notFoundslug);
    if (menu && menu.siteMapId) {
      this.loadCmsData(menu.siteMapId);
    }
    // let sitemapId = null;
    // obj = _(menus)
    //   .thru(function (coll: any) {
    //     return _.union(coll, _.map(coll, 'childs'));
    //   })
    //   .flatten()
    //   .find({ slug: notFoundslug });
    // if (obj) { sitemapId = obj.siteMapId; }
    // if (sitemapId) {
    //   this.loadCmsData(sitemapId);
    // }
  }
  
  /**
   * @description Navigate to Portal
   * @author njagadeesan
   * @date 2020-01-11
   * @param {DynamicRoute} dynamicRoute
   * @memberof PageNotFoundComponent
   */
  navigateToPortal(dynamicRoute: DynamicRoute): void {
    let route = dynamicRoute.route;
    if (route) {
      if (environment.betaPortal) {
        route = this._commonService.constructBetaUrl(route);
      }
      window.open(route, dynamicRoute.target);
    }
  }

}
